import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_CONTENT_RATING_REPORT: (query) => ({ query }),
    API: {
      GET_CONTENT_RATING_REPORT: apiResourceActionCreator('contentRatingReport'),
    },
  },
});

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/reports/content-rating${endpointQuery({ ...(query || {}) })}`, authToken, action.admin.api.getContentRatingReport);

function* getContentRatingReport(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.query));
};

const configuration = {
  name: 'getContentRatingReport',
  action: action,
  sagas: getContentRatingReport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingReport: true,
    }),
    success: (state, action) => {
      const updatedContentRatingReport = (!state.contentRatingReport || action.payload.contentRatingReport.skip === 0)
        ? action.payload.contentRatingReport
        : {
            ...action.payload.contentRatingReport,
            contentRating: state.contentRatingReport.contentRating.concat(action.payload.contentRatingReport.contentRating),
          };

      return ({
        ...state,
        isFetchingReport: false,
        contentRatingReport: updatedContentRatingReport,
      });
    },
    failed: (state, action) => ({
      ...state,
      isFetchingReport: false,
    }),
  },
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getContentRatingReport.js